import emailjs from 'emailjs-com';

// For Firebase JS SDK v7.20.0 and later, measurementId is optional

export const firebaseConfig = {
    apiKey: "AIzaSyAV4ksFVJK1XNX8n4AlghfJR8KK2MRGSzg",
    authDomain: "nazmus-sakib.firebaseapp.com",
    projectId: "nazmus-sakib",
    storageBucket: "nazmus-sakib.appspot.com",
    messagingSenderId: "498174793303",
    appId: "1:498174793303:web:21ea7f51a55b6613547512",
    measurementId: "G-T5V62FY6VX"
};

export const sendEmail = (e)=> {
    emailjs.sendForm('service_42544nf', 'template_2xmmhaq', e.target, 'user_qvCCcwGt20XiiU7ZwYCOy')
        .then((result) => {
            console.log(result.text);
        }, (error) => {
            console.log(error.text);
        });
    e.preventDefault();
    e.target.reset();
}